import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import React from "preact/compat";
import MenuObject from '../canvas/menu-object';
import store from "../store";
import util, { getContrast } from "../util";
import constants from "../constants";
import $ from "jquery";
import { addComponent, VIEWPORT_CENTER } from "../canvas/component";
import {
  Body,
  DailySpecial,
  ForTheKids,
  getTextTemplate, GrandOpening, HappyHolidays,
  HappyHour,
  HappyNewYear, Header, LimitedTimeOnly,
  NewAdditions,
  OnSpecial, OrderOnline,
  ScanTheCode,
  Since1999, Subheader,
  TwoForOne, ViewOurMenu
} from "../canvas/text-templates";
import designDomain from "../domain/designDomain";
import MenuItemDataImport from './MenuItemDataImport';
import { markAsModified } from '../canvas/mark-as-modified';

const { dispatch } = store;
const { goToView } = actions;

const isFirefox = util.isFirefox();

const Templates = [
  { label: "Happy Hour", fontFamily: "Nexa Rust Slab Black", key: HappyHour, textTransform: 'none', fontSize: '25px', color: '#EBA93F' },
  { label: "On Special!", fontFamily: "Pacifico", key: OnSpecial, textTransform: 'none', fontSize: '19px', color: '#47A7ED' },
  { label: "NEW ADDITIONS", fontFamily: "Lora", key: NewAdditions, textTransform: 'uppercase', fontSize: '15px', color: '#B52121' },
  { label: "2 FOR 1 TODAY", fontFamily: "Kirang Haerang", key: TwoForOne, textTransform: 'uppercase', fontSize: '27px', color: '#95E04B' },
  { label: "For the kids", fontFamily: "Gochi Hand", key: ForTheKids, textTransform: 'none', fontSize: '25px', color: '#B065D1' },
  { label: "Happy<br />New Year!", fontFamily: "Lobster", key: HappyNewYear, textTransform: 'none', fontSize: '30px', color: '#443576' },
  { label: "Since 1999", fontFamily: "Alperton", key: Since1999, textTransform: 'none', fontSize: '25px', color: '#F87C8F' },
  { label: "Scan the Code", fontFamily: "Anaconda", key: ScanTheCode, textTransform: 'uppercase', fontSize: '26px', color: '#333333' },
  { label: "Order Online", fontFamily: "Cherry Swash", key: OrderOnline, textTransform: 'none', fontSize: '25px', color: '#745133' },
  { label: "Grand Opening", fontFamily: "Diplomata SC", key: GrandOpening, textTransform: 'none', fontSize: '15px', color: '#FA8713' },
  { label: "View Our Menu", fontFamily: "Mocha Mattari", key: ViewOurMenu, textTransform: 'none', fontSize: '31px', color: '#568358' },
  { label: "Daily Special", fontFamily: "Handmade Dropshadow JNL", key: DailySpecial, textTransform: 'none', fontSize: '40px', color: '#5664CC' },
  { label: "Limited time only!", fontFamily: "Cookie", key: LimitedTimeOnly, textTransform: 'none', fontSize: '25px', color: '#EDBA31' },
  { label: "Happy Holidays", fontFamily: "Lemon Yellow Sun", key: HappyHolidays, textTransform: 'none', fontSize: '33px', color: '#EA1C1C' }
]

export default @connect(reduce, actions)
class AsideMenuObjectText extends Component {
  constructor() {
    super();

    this.state = {
      items: store.getState().menuObjectItems,
    }

    this.favoriteFontHeader = constants.favoriteFonts['HEADER'];
    this.favoriteFontSubheader = constants.favoriteFonts['SUB-HEADER'];
    this.favoriteFontBodyText = constants.favoriteFonts['BODY TEXT'];

  }

  addToCanvas(template, font) {
    const $page = util.getPageInViewport($('.page'));

    addComponent($page.attr('id'), getTextTemplate(template, font), {
      position: {
        left: VIEWPORT_CENTER,
        top: VIEWPORT_CENTER
      },
      isFromTemplate: true
    });

    if (store.getState().isMobileVersion) {
      store.dispatch(actions.setIsMobileAside(false));
    }
  }

  addNewItem(layout, isMOName, isMONotes) {
    let menuObjs = [];
    let firstItem = null;
    let secondItem = null;
    let moName = new MenuObject.MenuObjectName('Group Name');
    let moNotes = new MenuObject.MenuObjectNotes('Add an additional note for your groups');

    switch (layout) {
      case 'price-name-left':
        firstItem = new MenuObject.MenuItem('Item Name', '', 'Write a description that makes the ordinary sound extraordinary.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        secondItem = new MenuObject.MenuItem('Item Name', '', 'Talk about your food in a way that makes your brand memorable.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        if (isMOName) menuObjs.push(moName);
        if (isMONotes) menuObjs.push(moNotes);
        menuObjs.push(firstItem);
        menuObjs.push(secondItem);
        break;

      case 'price-name-right':
        firstItem = new MenuObject.MenuItem('Item Name', '', 'Use seasons to underscore the freshness of your food.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        secondItem = new MenuObject.MenuItem('Item Name', '', 'Whet appetites by including your sauces, seasonings and preparations.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        if (isMOName) menuObjs.push(moName);
        if (isMONotes) menuObjs.push(moNotes);
        menuObjs.push(firstItem);
        menuObjs.push(secondItem);
        break;

      case 'stacked':
        firstItem = new MenuObject.MenuItem('Item Name', '', 'The words used to describe your food are as important as the ingredients.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        secondItem = new MenuObject.MenuItem('Item Name', '', 'Talk about your food in a way that makes your brand memorable.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        if (isMOName) menuObjs.push(moName);
        if (isMONotes) menuObjs.push(moNotes);
        menuObjs.push(firstItem);
        menuObjs.push(secondItem);
        break;

      case 'prices-right-top':
        firstItem = new MenuObject.MenuItem('Item Name', '', 'Call out locally sourced ingredients in your descriptions.', [{ size: 'Size', price: '$' }, { size: 'Size', price: '$' }, { size: 'Size', price: '$' }], "", "", "", [], [], "", "");
        secondItem = new MenuObject.MenuItem('Item Name', '', 'A description reminds customers why they love your food so much.', [{ size: 'Size', price: '$' }, { size: 'Size', price: '$' }, { size: 'Size', price: '$' }], "", "", "", [], [], "", "");
        if (isMOName) menuObjs.push(moName);
        if (isMONotes) menuObjs.push(moNotes);
        menuObjs.push(firstItem);
        menuObjs.push(secondItem);
        break;

      case 'price-name-float-right':
        firstItem = new MenuObject.MenuItem('Item Name', '', 'Highlight your exotic ingredients by naming the country of origin.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        secondItem = new MenuObject.MenuItem('Item Name', '', 'If you are using organic ingredients, tell customers in your description.', [{ size: '', price: '$' }], "", "", "", [], [], "", "");
        if (isMOName) menuObjs.push(moName);
        if (isMONotes) menuObjs.push(moNotes);
        menuObjs.push(firstItem);
        menuObjs.push(secondItem);
        break;

      default:
        firstItem = new MenuObject.MenuItem('Item Name', '', 'Call out locally sourced ingredients in your descriptions.', [{ size: '', price: '$' }], "", "A1", "BIN", [], [], "", "");
        secondItem = new MenuObject.MenuItem('Item Name', '', 'A description reminds customers why they love your food so much.', [{ size: '', price: '$' }], "", "A2", "", [], [], "", "");
        if (isMOName) menuObjs.push(moName);
        if (isMONotes) menuObjs.push(moNotes);
        menuObjs.push(firstItem);
        menuObjs.push(secondItem);
    }
    this.addExampleItemsToMenu(layout, menuObjs);
  }

  addMenuItem() {
    const style = JSON.parse(MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE);
    const $first = $('.menu-object').first();
    const isMOName = $first.find('.mo-name').length > 0 && style.styles['mo-name'];
    const isMONotes = $first.find('.mo-notes').length > 0 && style.styles['mo-notes'];
    this.addNewItem("price-name-left", isMOName, isMONotes);
  }

  onNavClick(subview) {
    dispatch(goToView('text-mo'));
    store.dispatch(actions.goToSubview(subview));
  }


  addExampleItemsToMenu(layout, items) {
    MenuObject.addMenuItemsTemplateToCanvas(layout, items);

    if (store.getState().isMobileVersion) {
      store.dispatch(actions.setIsMobileAside(false));
    } else {
      this.setState({ items: items, isEditMode: true });
    }

    markAsModified();
  }

  render(props, state) {
    const style = JSON.parse(MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE);

    const $first = $('.menu-object').first();
    const isMOName = $first.find('.mo-name').length > 0 && style.styles['mo-name'];
    const isMONotes = $first.find('.mo-notes').length > 0 && style.styles['mo-notes'];
    const moNameStyle = isMOName ? {
      fontFamily: style.styles['mo-name']['font-family'],
      fontStyle: style.styles['mo-name']['font-style'],
      color: style.styles['mo-name']['color'],
      fontWeight: style.styles['mo-name']['font-weight'],
      textTransform: style.styles['mo-name']['text-transform'],
      textDecoration: style.styles['mo-name']['text-decoration'],
      textAlign: style.styles['mo-name']['text-align'],
    } : {};
    const moNoteStyle = isMONotes ? {
      fontFamily: style.styles['mo-notes']['font-family'],
      fontStyle: style.styles['mo-notes']['font-style'],
      color: style.styles['mo-notes']['color'],
      fontWeight: style.styles['mo-notes']['font-weight'],
      textTransform: style.styles['mo-notes']['text-transform'],
      textDecoration: style.styles['mo-notes']['text-decoration'],
      textAlign: style.styles['mo-notes']['text-align'],
    } : {};
    if (moNameStyle && moNameStyle.color) {
      const moNameColor = moNameStyle.color.toUpperCase() === '#FFF' ? '#FFFFFF' : moNameStyle.color;
      if (moNameColor && getContrast('#FFFFFF', moNameColor) < 1.3) {
        moNameStyle.color = '#ADADAD';
      }
    }

    if (moNoteStyle && moNoteStyle.color) {
      const moNoteColor = moNoteStyle.color?.toUpperCase() === '#FFF' ? '#FFFFFF' : moNoteStyle.color;
      if (moNoteColor && getContrast('#FFFFFF', moNoteColor) < 1.3) {
        moNoteStyle.color = '#ADADAD';
      }
    }

    const nameStyle = {
      fontFamily: style.styles.name['font-family'],
      fontStyle: style.styles.name['font-style'],
      color: style.styles.name['color'],
      fontWeight: style.styles.name['font-weight'],
      textTransform: style.styles.name['text-transform'],
      textDecoration: style.styles.name['text-decoration'],
    };

    const binStyle = {
      ...nameStyle,
      marginRight: '0.5em'
    }

    const descriptionStyle = {
      fontFamily: style.styles.description['font-family'],
      fontStyle: style.styles.description['font-style'],
      color: style.styles.description['color'],
      fontWeight: style.styles.description['font-weight'],
      textTransform: style.styles.description['text-transform'],
      textDecoration: style.styles.description['text-decoration'],
    };

    const nameColor = nameStyle.color?.toUpperCase() === '#FFF' ? '#FFFFFF' : nameStyle.color;
    if (getContrast('#FFFFFF', nameColor) < 1.3) {
      nameStyle.color = '#ADADAD';
    }

    const descriptionColor = descriptionStyle.color?.toUpperCase() === '#FFF' ? '#FFFFFF' : descriptionStyle.color;
    if (getContrast('#FFFFFF', descriptionColor) < 1.3) {
      descriptionStyle.color = '#ADADAD';
    }

    const dollarSign = <span className={'price'} style={{ color: `${nameStyle.color}` }}><b>$</b></span>;
    const dollarSignFirst = <span className={'first price'} style={{ color: `${nameStyle.color}` }}><b>$</b></span>;
    const dollarSignLast = <span className={'last price'} style={{ color: `${nameStyle.color}` }}><b>$</b></span>;

    const priceNameLeftTemplate = <div className="layout-container align-left" onClick={() => this.addNewItem("price-name-left", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name {dollarSign}</b></span>
      <span className="item-description" style={descriptionStyle}>Write a description that makes the ordinary sound extraordinary.</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name {dollarSign}</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable.</span>
    </div>;

    const priceNameRightTemplate = <div className="layout-container align-right" onClick={() => this.addNewItem("price-name-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name {dollarSign}</b></span>
      <span className="item-description" style={descriptionStyle}>Use the seasons to underscore the freshness of your food.</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name {dollarSign}</b></span>
      <span className="item-description" style={descriptionStyle}>Whet appetites by including your sauces, seasonings and preparations.</span>
    </div>;

    const stackedTemplate = <div className="layout-container align-center" onClick={() => this.addNewItem("stacked", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>The words used to describe your food are as important as the ingredients.<br />{dollarSign}</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable.<br />{dollarSign}</span>
    </div>;

    const pricesRightTopTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("prices-right-top", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <span className="item-name" style={nameStyle}>
        <b>Item Name</b>
        <span className="prices">
          <span className={'first'}>{dollarSign}</span>
          <span><b>$</b></span>
          <span className={'last'}>{dollarSign}</span>
        </span>
      </span>
      <span className="item-description" style={descriptionStyle}>Call out locally sourced<br /> ingredients in your<br /> descriptions.</span>
      <span className="item-name" style={{ ...nameStyle, marginTop: '4px' }}>
        <b>Item Name</b>
        <span className="prices">
          <span className={'first'}>{dollarSign}</span>
          <span><b>$</b></span>
          <span className={'last'}>{dollarSign}</span>
        </span>
      </span>
      <span className="item-description" style={descriptionStyle}>A description reminds<br /> customers why they love<br /> your food so much.</span>
    </div>;

    const binPriceColumnTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("bin-price-column", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px' }}>
          <div class="bin">A1</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
            <span className="prices">
              <span className={'first'}>{dollarSign}</span>
              <span><b>$</b></span>
              <span className={'last'}>{dollarSign}</span>
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>Call out locally sourced<br /> ingredients in your<br /> descriptions.</span>
        </div>
      </div>

      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px', marginTop: '4px' }}>
          <div class="bin">A2</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={{ ...nameStyle, marginTop: '4px' }}>
            <b>Item Name</b>
            <span className="prices">
              <span className={'first'}>{dollarSign}</span>
              <span><b>$</b></span>
              <span className={'last'}>{dollarSign}</span>
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>A description reminds<br /> customers why they love<br /> your food so much.</span>
        </div>
      </div>
    </div>;

    const binPriceColumnHeaderTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("bin-price-column-header", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '15px', marginTop: '-16px' }}>
          <div class="bin-header">BIN</div>
          <div class="bin">A1</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
            <span className="prices">
              <span className={'first'}>{dollarSign}</span>
              <span><b>$</b></span>
              <span className={'last'}>{dollarSign}</span>
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>Call out locally sourced<br /> ingredients in your<br /> descriptions.</span>
        </div>
      </div>

      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px', marginTop: '4px' }}>
          <div class="bin">A2</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={{ ...nameStyle, marginTop: '4px' }}>
            <b>Item Name</b>
            <span className="prices">
              <span className={'first'}>{dollarSign}</span>
              <span><b>$</b></span>
              <span className={'last'}>{dollarSign}</span>
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>A description reminds<br /> customers why they love<br /> your food so much.</span>
        </div>
      </div>
    </div>;

    const priceNameFloatRightTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("price-name-float-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}>
        <b>Item Name</b>
        <span className="prices">
          {dollarSign}
        </span>
      </span>
      <span className="item-description" style={descriptionStyle}>Highlight your exotic ingredients by naming the country of origin.</span>
      <br />
      <span className="item-name" style={nameStyle}>
        <b>Item Name</b>
        <span className="prices">
          {dollarSign}
        </span>
      </span>
      <span className="item-description" style={descriptionStyle}>If you are using organic ingredients, tell customers in your description.</span>
    </div>;

    const priceNameFloatRightWithDotLeadersTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("price-name-float-right-with-dot-leaders", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}>
        <b>Item Name</b>
        <div className="dot-leader" style={{ borderBottom: `0.1em dotted ${nameStyle.color}` }}></div>
        <span className="prices">
          {dollarSign}
        </span>
      </span>
      <span className="item-description" style={descriptionStyle}>Highlight your exotic ingredients by naming the country of origin.</span>
      <br />
      <span className="item-name" style={nameStyle}>
        <b>Item Name</b>
        <div className="dot-leader" style={{ borderBottom: `0.1em dotted ${nameStyle.color}` }}></div>
        <span className="prices">
          {dollarSign}
        </span>
      </span>
      <span className="item-description" style={descriptionStyle}>If you are using organic ingredients, tell customers in your description.</span>
    </div>;

    const binWithDotLeadersTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("bin-with-dot-leaders", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px' }}>
          <div class="bin">A1</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
            <div className="dot-leader" style={{ borderBottom: `0.1em dotted ${nameStyle.color}` }}></div>
            <span className="prices">
              {dollarSign}
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>Call out locally sourced ingredients in your descriptions.</span>
        </div>
      </div>
      <br />
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px' }}>
          <div class="bin">A2</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
            <div className="dot-leader" style={{ borderBottom: `0.1em dotted ${nameStyle.color}` }}></div>
            <span className="prices">
              {dollarSign}
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>A description reminds customers why they love your food so much.</span>
        </div>
      </div>
    </div>;

    const binHeaderWithDotLeadersTemplate = <div className="layout-container align-left prices-right-top" onClick={() => this.addNewItem("bin-header-with-dot-leaders", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '15px' }}>
          <div class="bin-header">BIN</div>
          <div class="bin">A1</div>
        </div>
        <div style="flex: 1; margin-top: 16px;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
            <div className="dot-leader" style={{ borderBottom: `0.1em dotted ${nameStyle.color}` }}></div>
            <span className="prices">
              {dollarSign}
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>Call out locally sourced ingredients in your descriptions.</span>
        </div>
      </div>
      <br />
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '15px' }}>
          <div class="bin">A2</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
            <div className="dot-leader" style={{ borderBottom: `0.1em dotted ${nameStyle.color}` }}></div>
            <span className="prices">
              {dollarSign}
            </span>
          </span>
          <span className="item-description" style={descriptionStyle}>A description reminds customers why they love your food so much.</span>
        </div>
      </div>
    </div>;

    const priceNameCenterTemplate = <div className="layout-container align-center" onClick={() => this.addNewItem("price-name-center", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name {dollarSign}</b></span>
      <span className="item-description" style={descriptionStyle}>The words used to describe your food are as important as the ingredients.</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name {dollarSign}</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable.</span>
    </div>;

    const priceDescriptionLeftTemplate = <div className="layout-container align-left price-description-left" onClick={() => this.addNewItem("price-description-left", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Write a description that makes the ordinary sound extraordinary. {dollarSign}</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable. {dollarSign}</span>
    </div>;

    const priceDescriptionFloatRightTemplate = <div className="layout-container align-left price-description-float-right" onClick={() => this.addNewItem("price-description-float-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Use seasons to underscore the freshness of your food. {dollarSign}</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable. {dollarSign}</span>
    </div>;

    const priceDescriptionCenterTemplate = <div className="layout-container align-center price-description-center" onClick={() => this.addNewItem("price-description-center", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>The words used to describe your food are as important as the ingredients. {dollarSign}</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable. {dollarSign}</span>
    </div>;

    const priceDescriptionRightTemplate = <div className="layout-container align-right price-description-right" onClick={() => this.addNewItem("price-description-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Use the seasons to underscore the freshness of your food. {dollarSign}</span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Whet appetites by including your sauces, seasonings and preparations. {dollarSign}</span>
    </div>;

    const stackedLeftTemplate = <div className="layout-container align-left stacked-left" onClick={() => this.addNewItem("stacked-left", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Write a description that makes the ordinary sound extraordinary.</span>
      {dollarSign}
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable. </span>
      {dollarSign}
    </div>;

    const compactTemplate = <div className="layout-container align-left compact" onClick={() => this.addNewItem("compact", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b><span className="item-description" style={descriptionStyle}>Write a description that makes the ordinary sound extraordinary. {dollarSign}</span></span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b><span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable. {dollarSign}</span></span>
    </div>;

    const compactCenterTemplate = <div className="layout-container align-center compact-center" onClick={() => this.addNewItem("compact-center", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="item-name" style={nameStyle}><b>Item Name</b><span className="item-description" style={descriptionStyle}>Write a description that makes the ordinary sound extraordinary. {dollarSign}</span></span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b><span className="item-description" style={descriptionStyle}>Talk about your food in a way that makes your brand memorable. {dollarSign}</span></span>
    </div>;

    const pricesRightBottomTemplate = <div className="layout-container align-left prices-right-bottom" onClick={() => this.addNewItem("prices-right-bottom", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>
        Call out locally sourced ingredients in your descriptions.
        <span className="prices">
          {dollarSignFirst}
          {dollarSign}
          {dollarSignLast}
        </span>
      </span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>
        A description reminds customers why they love your food so much.
        <span className="prices">
          {dollarSignFirst}
          {dollarSign}
          {dollarSignLast}
        </span>
      </span>
    </div>;

    const PricesRightWithDotLeadersTemplate = <div className="layout-container align-left prices-right-bottom" onClick={() => this.addNewItem("prices-right-with-dot-leaders", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>
        <span>
          Call out locally sourced ingredients in your descriptions.
          <span className="dot-leader" style={{ borderBottom: '0.1em dotted black', display: 'inline-block', width: '28px' }}></span>
        </span>
        <span className="prices">
          {dollarSignFirst}
          {dollarSign}
          {dollarSignLast}
        </span>
      </span>
      <br />
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>
        <span>
          Talk about your food.
          <span className="dot-leader" style={{ borderBottom: '0.1em dotted black', display: 'inline-block', width: '6px' }}></span>
        </span>
        <span className="prices">
          {dollarSignFirst}
          {dollarSign}
          {dollarSignLast}
        </span>
      </span>
    </div>;

    const pricesRightTemplate = <div className="layout-container align-left prices-right" onClick={() => this.addNewItem("prices-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <span className="item-name" style={nameStyle}><b>Item Name</b></span>
      <span className="item-description" style={descriptionStyle}>
        Call out locally sourced ingredients in your descriptions.
        <span className="prices">
          {dollarSignFirst}
          {dollarSign}
          {dollarSignLast}
        </span>
      </span>
      <br />
      <span className="item-name" style={nameStyle}>
        <b>Item Name</b>
      </span>
      <span className="item-description" style={descriptionStyle}>
        A description reminds customers why they love your food so much.
        <span className="prices">
          {dollarSignFirst}
          {dollarSign}
          {dollarSignLast}
        </span>
      </span>
    </div>;

    const pricesRightInlineTopTemplate = <div className="layout-container align-left prices-right" onClick={() => this.addNewItem("prices-right", isMOName, isMONotes)}>
    {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
    {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
    <span className="header">
      <span>SIZE</span>
      <span>SIZE</span>
      <span>SIZE</span>
    </span>
    <span className="item-name" style={nameStyle}>
      <b>Item Name</b>
      <span className="prices">
          <span className={'first'}>{dollarSign}</span>
          <span><b>$</b></span>
          <span className={'last'}>{dollarSign}</span>
        </span>
    </span>
    <span className="item-description" style={descriptionStyle}>
      Call out locally sourced ingredients in your descriptions.
      <span className="prices">
        {dollarSignFirst}
        {dollarSign}
        {dollarSignLast}
      </span>
    </span>
    <br />
    <span className="item-name" style={nameStyle}>
      <b>Item Name</b>
    </span>
    <span className="item-description" style={descriptionStyle}>
      A description reminds customers why they love your food so much.
    </span>
    </div>;

    const binPricesRightTemplate = <div className="layout-container align-left prices-right" onClick={() => this.addNewItem("prices-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px' }}>
          <div class="bin">A1</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}><b>Item Name</b></span>
          <span className="item-description" style={descriptionStyle}>
            Call out locally sourced ingredients in your descriptions.
            <span className="prices">
              {dollarSignFirst}
              {dollarSign}
              {dollarSignLast}
            </span>
          </span>
        </div>
      </div>
      <br />

      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px' }}>
          <div class="bin">A2</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
          </span>
          <span className="item-description" style={descriptionStyle}>
            A description reminds customers why they love your food so much.
            <span className="prices">
              {dollarSignFirst}
              {dollarSign}
              {dollarSignLast}
            </span>
          </span>
        </div>
      </div>
    </div>;

    const binPricesRightHeaderTemplate = <div className="layout-container align-left prices-right" onClick={() => this.addNewItem("prices-right", isMOName, isMONotes)}>
      {isMOName && <span className="mo-name" style={moNameStyle}>Group Name</span>}
      {isMONotes && <span className="mo-notes" style={moNoteStyle}>Add an additional note for your groups</span>}
      <span className="header">
        <span>SIZE</span>
        <span>SIZE</span>
        <span>SIZE</span>
      </span>
      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '15px', marginTop: '-16px' }}>
          <div class="bin-header">BIN</div>
          <div class="bin">A1</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}><b>Item Name</b></span>
          <span className="item-description" style={descriptionStyle}>
            Call out locally sourced ingredients in your descriptions.
            <span className="prices">
              {dollarSignFirst}
              {dollarSign}
              {dollarSignLast}
            </span>
          </span>
        </div>
      </div>
      <br />

      <div class="bin-item-wrapper" style="display: flex;">
        <div class="bin-entry" style={{ ...binStyle, minWidth: '11px' }}>
          <div class="bin">A2</div>
        </div>
        <div style="flex: 1;">
          <span className="item-name" style={nameStyle}>
            <b>Item Name</b>
          </span>
          <span className="item-description" style={descriptionStyle}>
            A description reminds customers why they love your food so much.
            <span className="prices">
              {dollarSignFirst}
              {dollarSign}
              {dollarSignLast}
            </span>
          </span>
        </div>
      </div>
    </div>;

    const candidateArr = [{
      layout: 'price-name-float-right-with-dot-leaders',
      content: priceNameFloatRightWithDotLeadersTemplate
    }, {
      layout: 'price-description-float-right',
      content: priceDescriptionFloatRightTemplate
    }, {
      layout: 'price-description-center',
      content: priceDescriptionCenterTemplate
    }, {
      layout: 'price-description-right',
      content: priceDescriptionRightTemplate
    }, {
      layout: 'stacked-left',
      content: stackedLeftTemplate
    }, {
      layout: 'compact',
      content: compactTemplate
    }, {
      layout: 'compact-center',
      content: compactCenterTemplate
    }, {
      layout: 'prices-right-bottom',
      content: pricesRightBottomTemplate
    }, {
      layout: 'prices-right-with-dot-leaders',
      content: PricesRightWithDotLeadersTemplate
    }, {
      layout: 'prices-right',
      content: pricesRightTemplate
    }, {
      layout: 'prices-right-inline-top',
      content: pricesRightInlineTopTemplate
    }, {
      layout: 'price-name-float-right',
      content: priceNameFloatRightTemplate
    }, {
      layout: 'bin-with-dot-leaders',
      content: binWithDotLeadersTemplate,
    }, {
      layout: 'bin-header-with-dot-leaders',
      content: binHeaderWithDotLeadersTemplate,
    }, {
      layout: 'bin-price-column',
      content: binPriceColumnTemplate,
    }, {
      layout: 'bin-price-column-header',
      content: binPriceColumnHeaderTemplate,
    }, {
      layout: 'bin-prices-right',
      content: binPricesRightTemplate,
    }, {
      layout: 'bin-prices-right-header',
      content: binPricesRightHeaderTemplate,
    }];

    const arr = [{
      layout: 'price-name-left',
      content: priceNameLeftTemplate
    }, {
      layout: 'price-name-center',
      content: priceNameCenterTemplate
    }, {
      layout: 'price-name-right',
      content: priceNameRightTemplate
    }, {
      layout: 'price-description-left',
      content: priceDescriptionLeftTemplate
    }, {
      layout: 'stacked',
      content: stackedTemplate
    }, {
      layout: 'prices-right-top',
      content: pricesRightTopTemplate
    }];

    let templates = [];
    candidateArr.forEach(it => {
      if (it.layout === style.layout) {
        templates.push(it.content);
      }
    });
    arr.forEach(it => {
      if (it.layout === style.layout) {
        templates.unshift(it.content);
      } else {
        templates.push(it.content);
      }
    })

    if (templates.length > 6) {
      templates.splice(-1);
    }

    const view = store.getState().view;
    const subview = store.getState().subview;

    return (
      <div className="menu-object-content mo-deselect-container">
        <div className="scroller">
          <div>
            {this.props.posFeature && <MenuItemDataImport
              menuGroups={this.props.menuGroups}
              menuGroupsSource={this.props.menuGroupsSource}
              menuGroupsSourceInProgress={this.props.menuGroupsSourceInProgress}
              isSquare={this.props.isSquare}
              isTreez={this.props.isTreez}
              isPopmenu={this.props.isPopmenu}
              toastEmail={this.props.toastEmail}
              designId={this.props.designId}
              memberId={this.props.memberId}
              addMenuItem={this.addMenuItem.bind(this)}
              isMobileVersion={this.props.isMobileVersion}
              posAutoSyncEnabled={this.props.posAutoSyncEnabled}
              posSyncPendingCount={this.props.posSyncPendingCount}
              isFreemium={this.props.isFreemium}
              hasPosData={this.props.hasPosData}
              hasPdfPermission={this.props.hasPdfPermission}
              setActiveMember={this.props.setActiveMember}
            />}

            <ul className={"sample-text"}>
              <li onClick={() => this.addToCanvas(Header, this.favoriteFontHeader)}><a style={{
                fontFamily: this.favoriteFontHeader?.name ?? "Pathway Gothic One",
                fontSize: "30px",
                fontWeight: (this.favoriteFontHeader?.bold ? 'bold' : ''),
                fontStyle: this.favoriteFontHeader?.italic ? 'italic' : '',
                textDecoration: this.favoriteFontHeader?.underline ? 'underline' : '',
              }}>ADD HEADER TEXT</a></li>
              <li onClick={() => this.addToCanvas(Subheader, this.favoriteFontSubheader)}><a style={{
                fontSize: "18px",
                fontFamily: this.favoriteFontSubheader?.name ?? "PT Mono",
                fontWeight: (this.favoriteFontSubheader?.bold ? 'bold' : ''),
                fontStyle: this.favoriteFontSubheader?.italic ? 'italic' : '',
                textDecoration: this.favoriteFontSubheader?.underline ? 'underline' : '',
              }}>Add Subheader Text</a></li>
              <li onClick={() => this.addToCanvas(Body, this.favoriteFontBodyText)}><a style={{
                fontSize: "15px",
                fontFamily: this.favoriteFontBodyText?.name ?? "Futura PT",
                fontWeight: (this.favoriteFontBodyText?.bold ? 'bold' : ''),
                fontStyle: this.favoriteFontBodyText?.italic ? 'italic' : '',
                textDecoration: this.favoriteFontBodyText?.underline ? 'underline' : '',
              }}>Add Body Text</a></li>
            </ul>

            <div className={'mo-templates'}>
              <div className={'buttons add-menu-group'}>
                <a className={'btn secondary1 medium full'} onClick={() => this.addMenuItem()}>+ Add Menu Group</a>
              </div>

              {templates}
            </div>

            <ul className={"templates"}>
              {
                Templates.map(it => <li>
                  <div className={"component template" + (isFirefox ? " firefox" : "")} data-text-preset={it.key} style={{
                    fontFamily: it.fontFamily,
                    textTransform: it.textTransform,
                    fontSize: it.fontSize,
                    color: it.color,
                  }} dangerouslySetInnerHTML={{ __html: it.label }}>&nbsp;</div>
                </li>)
              }
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
